type EnvironmentName = 'development' | 'test' | 'staging' | 'production';

function parseUrl(name: string, value: string | undefined, fallback: string): string {
  const candidate = value?.trim() || fallback;
  if (!candidate) throw new Error(`${name} is required for this environment.`);
  let url: URL;
  try { url = new URL(candidate, window.location.origin); } catch { throw new Error(`${name} must be a valid URL.`); }
  if (import.meta.env.PROD && url.protocol !== 'https:') throw new Error(`${name} must use HTTPS in production.`);
  return candidate.replace(/\/+$/, '');
}

function environmentName(value: string | undefined): EnvironmentName {
  const candidate = value?.trim() || (import.meta.env.PROD ? 'production' : import.meta.env.MODE === 'test' ? 'test' : 'development');
  if (!['development', 'test', 'staging', 'production'].includes(candidate)) throw new Error('VITE_ENVIRONMENT is invalid.');
  return candidate as EnvironmentName;
}

const production = import.meta.env.PROD;

export const publicEnv = Object.freeze({
  environment: environmentName(import.meta.env.VITE_ENVIRONMENT),
  apiBaseUrl: parseUrl('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL, production ? '' : '/api'),
  socketUrl: parseUrl('VITE_SOCKET_URL', import.meta.env.VITE_SOCKET_URL, production ? '' : window.location.origin),
  publicAppUrl: parseUrl('VITE_PUBLIC_APP_URL', import.meta.env.VITE_PUBLIC_APP_URL, production ? '' : window.location.origin)
});

